import classNames from 'classnames'
import dayjs from 'dayjs'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { useEffect, useRef, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import MaterialIcon from '../../components/MaterialIcon'
import ModalConfirm from '../../components/ModalConfirm'
import { usePartialUpdateProposta, useProposta, usePropostaFinalizza } from '../../hooks/proposte'
import CardDettaglio from './CardDettaglio'
import { CardElencoBilance } from './CardElencoBilance'
import { CardStorico } from './CardStorico'

export default function PropostaDettaglio() {
  const { id } = useParams()
  const { data: proposta, refetch } = useProposta(String(id))
  const router = useNavigate()
  const [isOpenAnnulla, setIsOpenAnnulla] = useState(false)
  const [modalStateAnnulla, modalActionsAnnulla] = useModalTrigger()
  const [modalConfirmFinalizza, modalActionsFinalizza] = useModalTrigger()

  const annullaRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (annullaRef.current && !annullaRef.current.contains(event.target as Node)) {
        setIsOpenAnnulla(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [annullaRef])

  const { mutateAsync: updatePartialProposta } = usePartialUpdateProposta()
  const { mutateAsync: finalizzaProposta } = usePropostaFinalizza(id ?? '')

  const propostaCompilabile = ['inviata', 'sollecitata', 'scaduta'].includes(proposta?.stato ?? '')

  return (
    <div className="page mb-5">
      <div className="row mt-4">
        <div className="col-12">
          <div className="d-flex align-items-center">
            <div
              onClick={() => {
                router(-1)
              }}
              className="p-sm no-link d-flex align-items-center pointer"
            >
              <span className="material-icons text-secondary">group</span>
              <span className="ms-2">Lista proposte</span>
            </div>
            <span className="material-icons text-secondary">chevron_right</span>
            <span className="ms-2 p-sm  bg-secondary-light p-2 text-secondary rounded">Dettaglio proposta</span>
          </div>
        </div>
        <div className="col-12 d-flex align-items-center mt-2">
          <h1 className="title">{proposta?.cliente_ragione_sociale}</h1>
          {propostaCompilabile && (
            <div className="ms-3 position-relative">
              <Button
                onClick={() => {
                  setIsOpenAnnulla(!isOpenAnnulla)
                }}
                variant="light"
                className="text-secondary d-flex align-items-center"
                type="button"
              >
                <span className="material-icons">more_horiz</span>
              </Button>
              {isOpenAnnulla && (
                <div
                  className="list-group position-absolute"
                  ref={annullaRef}
                  style={{
                    zIndex: 1000,
                    left: '0',
                    width: '200px',
                    boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.1)',

                    borderRadius: '5px',
                  }}
                >
                  <button
                    onClick={() => {
                      modalActionsAnnulla.open(proposta)
                    }}
                    className="list-group-item list-group-item-action d-flex align-items-center text-danger"
                  >
                    <span
                      className="material-icons me-2"
                      style={{
                        fontSize: '16px',
                      }}
                    >
                      delete
                    </span>
                    Annulla proposta
                  </button>
                </div>
              )}
            </div>
          )}
          <div className="flex-grow-1"></div>
          {propostaCompilabile && (
            <Button
              onClick={() => {
                const wx = window.open(
                  `/form-proposta/${id}`,
                  'Compila proposta',
                  'height=500,width=800,resizable=yes,scrollbars=yes'
                )
                wx?.addEventListener('unload', () => {
                  refetch()
                })
              }}
              variant="secondary"
              className="text-white d-flex align-items-center"
              type="button"
            >
              Compila
            </Button>
          )}
          {proposta?.stato === 'accettata' && (
            <Button
              onClick={() => {
                modalActionsFinalizza.open(proposta)
              }}
              variant="secondary"
              className="text-white d-flex align-items-center"
              type="button"
            >
              Finalizza
            </Button>
          )}
          {proposta?.stato === 'prenotata' && (
            <Button
              variant="secondary"
              className="text-white d-flex align-items-center"
              onClick={async () => {
                window.open(proposta.certificato_prenotazione ?? '', '_blank')
              }}
            >
              <MaterialIcon icon="download" className="me-2" />
              <span>Scarica certificato</span>
            </Button>
          )}
        </div>
        <div className="col-12 d-flex align-items-center mt-2">
          <div
            className={classNames('badge text-capitalize', {
              'badge-state-success': proposta?.stato === 'accettata' || proposta?.stato === 'prenotata',
              'badge-state-all': proposta?.stato === 'scaduta',
              'badge-state-warning': proposta?.stato === 'inviata' || proposta?.stato === 'sollecitata',
              'badge-state-danger': proposta?.stato === 'rifiutata' || proposta?.stato === 'annullata',
            })}
          >
            {proposta?.stato}
          </div>
          <div className="ms-3">
            <span>Inviata in data: </span>
            {dayjs(proposta?.data_creazione).format('DD/MM/YYYY')}
          </div>
        </div>
        <div className="col-12">
          <div className="row mt-3">
            <div className="col-md-5">
              <CardDettaglio proposta={proposta} />
              <CardStorico proposta={proposta} />
            </div>
            <div className="col-md-7">
              <CardElencoBilance proposta={proposta} />
            </div>
          </div>
        </div>
      </div>
      <ModalConfirm
        isOpen={modalStateAnnulla.isOpen}
        toggle={modalActionsAnnulla.close}
        title="Annulla proposta"
        body="Sei sicuro di voler annullare questa proposta?"
        action={async () => {
          await updatePartialProposta({
            id: proposta?.id,
            stato: 'annullata',
          })
          modalActionsAnnulla.close()
        }}
        cancelText="Annulla"
        confirmText="Annulla proposta"
      />
      <ModalConfirm
        isOpen={modalConfirmFinalizza.isOpen}
        toggle={modalActionsFinalizza.close}
        title="Finalizza proposta"
        body="Sei sicuro di voler finalizzare questa proposta? Verrà creato un intervento per ogni bilancia presente nella proposta."
        action={() => {
          finalizzaProposta()
          modalActionsFinalizza.close()
          refetch()
        }}
        cancelText="Annulla"
        confirmText="Finalizza proposta"
      />
    </div>
  )
}
